<template>
    <div id="search2021715">
        <el-form ref="searchForm" :model="query" label-width="100px" margin-top = "0" id="searchForm_iotDevice">
      <el-col :span="5">
        <el-form-item label="费用种类">
          <el-select
            v-model="query.subjectId"
            placeholder="全部"
            style="width: 100%"
           
          >
             <el-option
                        v-for="item in subjectList"
                        :key="item"
                        :value="item.id"
                        :label="item.name"
                    >
                    </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item label="账单状态">
          <el-select v-model="query.payFlag" style="width: 100%;" clearable placeholder="全部">
             <el-option
                v-for="item in payStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="账单月份">
          <el-date-picker
          v-model="query.billcycle"
          type="monthrange"
          value-format="yyyyMM"
          :unlink-panels="true"
          range-separator="至"
          start-placeholder="开始月份"
          end-placeholder="结束月份">
        </el-date-picker>
        </el-form-item>
      </el-col>
     
      <el-col :span="5">
        <el-form-item label="支付方式">
          <el-select v-model="query.payType" placeholder="全部" style="width: 100%;" clearable>
             <el-option
                style="padding-left: 10px;"
                v-for="item in payTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="23"  style="display:flex;justify-content: flex-end">
              <el-button icon="el-icon-search" size="small" type="primary" @click="search" :disabled="subjectDisabledFlag">
                搜索
              </el-button>
              <el-button icon="el-icon-delete" size="small" @click="searchReset">
                重置
              </el-button>
      </el-col>
    </el-form>
     
    <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page.sync="page"
                   v-model="form"
                   ref="crud"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @on-load="onLoad"
                   @refresh-change="onLoad"
        >
           <template slot="payFlag" slot-scope="scope">
               <span :class="scope.row.payFlag=='0'?'red':'green'">{{scope.row.$payFlag}}</span>
           </template>
    </avue-crud>
      
    </div>
</template>

<script>
  import {
  getAccountSearch,getSubjectList
} from '@/api/charge/charge-pay';
import { getDictionaryWithIntKey } from '../../../api/common';
import { getDictionary } from '../../../api/common';
    export default {
        props:{
            searchItem:{}
        },
         data() {
        return {
            loading: true,
            query: {
            payFlag:"",
            payType:'',
            subjectId:'',
            billcycleNo:'',
            billcycleEndNo:'',
            billcycle:[]
            },
            subjectDisabledFlag:true,
            form:{},
            data:[],
            option:{
                    height: '500',
                    calcHeight: 500,
                    tip: false,
                    border: true,
                    index: true,
                    indexLabel: "序号",
                    addBtn:false,
                    viewBtn: false,
                    selection: false,
                    menu:false,
                     column:[
                         {
                                    label: "费用种类",
                                    prop: "subjectName",
                                   
                        },
                         {
                                    label: "收费周期",
                                    prop: "billcycleNo",
                                   
                        },
                        {
                                    label: "开始日期",
                                    prop: "billStartDate",
                                   
                        },
                        {
                                    label: "结束日期",
                                    prop: "billEndDate",
                                   
                        },
                        {
                                    label: "账单",
                                    prop: "billAmount",
                                   
                        },
                        {
                                    label: "账单状态",
                                    prop: "payFlag",
                                    slot:true,
                                     props:{
                                        label:'title',
                                        value:'payFlag'
                                    },
                                    dicData:[{
                                        payFlag:1,
                                        title:'已支付'
                                    },
                                    {
                                        payFlag:0,
                                        title:'未支付'
                                    }]
                                   
                        },
                        {
                                    label: "支付方式",
                                    type:'select',
                                    prop: "payType",
                                    dataType:'number',
                                    props:{
                                        label:'dictValue',
                                        value:'dictKey'
                                    },
                                    dicUrl:'/api/blade-system/dict/dictionary?code=pay_type'

                                   
                        },
                        {
                                    label: "支付时间",
                                    prop: "payTime",
                                   
                        },
                        {
                                    label: "收费人",
                                    prop: "cashierName",
                                   
                        },
                        {
                                    label: "户主",
                                    prop: "ownerName",
                                   
                        },
                        {
                                    label: "备注",
                                    prop: "remark",
                                   
                        },
                     ]
            },
            page: {
                pageSize: 10,
                currentPage: 1,
                total: 0
            },
            subjectList:[],
            payTypeList:[],
            payStatusList: [
                {
                    label: '全部',
                    value: '',
                },
                {
                    label: '已支付',
                    value: 1,
                },
                {
                    label: '未支付',
                    value: 0,
                },
            ],
            billList:[]
        }
      },
     mounted() {
         this.initSelectList();
     },
     methods:{
         //表格清空
         restTable(){
          //数据清空
          this.data = []
          //分页清空
          this.page.total = 0  
          },
         subjectDisabled(){
           this.subjectDisabledFlag = true;
         },
         subjectActive(){
           this.subjectDisabledFlag = false;
         },
         searchReset(){
             this.query ={
            payFlag:"",
            payType:'',
            subjectId:'',
            billcycleNo:'',
            billcycleEndNo:'',
            billcycle:[]
            }
            //房屋信息
            this.query.targetId = this.searchItem.targetId
            //重置刷新
            this.onLoad();
         },
         search(){
             console.log('账单查询')
             this.query.targetId = this.searchItem.targetId
             console.log("query",this.query)
             this.onLoad();
         },
        initSelectList() {
            getDictionaryWithIntKey('fee_sort').then((data) => {
                this.feeSortList = data.data;
            });
            getDictionary('pay_type').then((data) => {
                this.payTypeList = data.data;
                this.payTypeList.unshift({dictKey:'',dictValue:'全部'});
            });
             getSubjectList().then((res)=>{
                this.subjectList = res.data;
                this.subjectList.unshift({id:'',name:'全部'});
                // this.subjectIds = [this.subjectList[0].id];
            })
        },
        currentChange(currentPage) {
                this.page.currentPage = currentPage;
        },
        sizeChange(pageSize) {
            this.page.pageSize = pageSize;
        },
        onLoad(page) {
          console.log("状态",this.subjectDisabledFlag)
          if(this.query.billcycle.length>0){
            this.query.billcycleNo = this.query.billcycle[0]
            this.query.billcycleEndNo = this.query.billcycle[1]
          }
         
          if(!this.subjectDisabledFlag){
            page = page || this.page;
            this.loading = true;
            getAccountSearch(
                  Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
              ).then(({data}) => {
                  this.page.total = data.total;
                  this.data = data.records;
                  this.loading = false;
                  this.selectionClear();
            });  
          }else{
            this.loading = false
          }
                      
        }
     }
    }
  </script>

<style>
#search2021715 .el-input__icon{
  line-height: 32px
}
</style>
<style scoped >
.red{
    color: red
}
.green{
    color: rgb(54, 230, 78)
}
</style>